var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticStyle:{"position":"fixed","top":"0","left":"0","z-index":"99999","pointer-events":"none","opacity":".7"},attrs:{"width":"200px","src":_vm.pageData.baseURL + 'template/accueil/images/beta.png',"aspect-ratio":"1.7","contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./template/accueil/components/DevIndicatore.vue?vue&type=template&id=c759a930&scoped=true&
// module id = 943
// module chunks = 0